import { useLocale } from '@hooks/useLocale';
import { Group, Text } from '@mantine/core';
import React from 'react';

const TestModeUnsub: React.FC = () => {
    const { t } = useLocale();
    return (
        <Group className="gap-2 p-3 mb-4 bg-white rounded-lg border border-gray-250">
            <Text className="text-sm font-semibold text-gray-800">
                {t('unsubscribe_group.unsubscribe_warning')}
            </Text>
            <Text className="text-sm font-medium text-gray-600">
                {t('unsubscribe_group.unsubscribe_warning_description')}
            </Text>
        </Group>
    );
};

export default React.memo(TestModeUnsub);
